import { SIZE } from 'baseui/input';

import type { Size } from 'baseui/input';

export const INPUT_SIZE = {
  xs: SIZE.mini,
  sm: SIZE.compact,
  md: SIZE.default,
  lg: SIZE.large,
} as const;

export type TInputSizeAlias = keyof typeof INPUT_SIZE;

export type TInputSize = TInputSizeAlias | Size;

export const resolveInputSize = (size?: TInputSize): Size | undefined => {
  if (!size) return undefined;
  return size in INPUT_SIZE
    ? INPUT_SIZE[size as TInputSizeAlias]
    : (size as Size);
};

export const INPUT_PILL_RADIUS = '9999px';

export const INPUT_SEARCH_WIDTH = '340px';

export const INPUT_CLEAR_ICON_SIZE = '16px';

export const INPUT_XS_HEIGHT = '28px';

export const INPUT_OVERRIDES = {
  pill: { Root: { style: { borderRadius: INPUT_PILL_RADIUS } } },
  xsHeight: {
    Root: { style: { height: INPUT_XS_HEIGHT, boxSizing: 'border-box' } },
    Input: { style: { paddingTop: '2px', paddingBottom: '2px' } },
  },
  flushEnhancers: {
    Root: { style: { paddingLeft: 0, paddingRight: 0 } },
    StartEnhancer: { style: { padding: 0 } },
    EndEnhancer: { style: { padding: 0 } },
  },
  alignRight: { Input: { style: { textAlign: 'right' } } },
  hideNumberSpinners: {
    Input: {
      style: {
        '::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
        '::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
        MozAppearance: 'textfield',
      },
    },
  },
  hideMaskToggle: { MaskToggleButton: { style: { display: 'none' } } },
  search: {
    Root: { style: { borderRadius: INPUT_PILL_RADIUS } },
    StartEnhancer: { style: { padding: '0px' } },
    ClearIcon: {
      style: {
        width: `${INPUT_CLEAR_ICON_SIZE} !important`,
        height: `${INPUT_CLEAR_ICON_SIZE} !important`,
      },
    },
  },
};

export const DENSE_CONTROL_CONTAINER = { style: { marginBottom: 0 } };

export const DENSE_CAPTION = {
  style: { marginTop: 0, marginBottom: 0, lineHeight: 0 },
};
